import {VERDICT_LIBELLES} from './tokens.js';

// F11 : export de la sélection courante (CSV / GeoJSON). JS pur.

export const COLONNES = ['nomenclature', 'adresse', 'commune', 'patrimoine', 'quantite', 'statut', 'etat', 'dernierPassage', 'elementsEnDefaut', 'nbPhotos', 'lat', 'lng'];

function proprietes(pav, etat, index) {
    const patrimoine = index.patrimoineById.get(pav.patrimoineId);
    return {
        nomenclature: pav.nomenclature,
        adresse: pav.adresse == null ? '' : String(pav.adresse).trim(),
        commune: pav.communeLibelle,
        patrimoine: patrimoine ? patrimoine.libelle : '',
        quantite: pav.quantite,
        statut: pav.statut,
        etat: VERDICT_LIBELLES[etat.verdict],
        dernierPassage: etat.date || '',
        elementsEnDefaut: etat.elementsEnDefaut.join(' | '),
        nbPhotos: etat.nbPhotos,
        lat: pav.lat,
        lng: pav.lng,
    };
}

function champ(valeur) {
    let texte = valeur == null ? '' : String(valeur);
    // Neutralise l'interprétation en formule par un tableur : seuls les TEXTES commençant par = + - @ ou une
    // tabulation sont préfixés d'une apostrophe (les nombres, ex. lng négatif, restent intacts).
    if (typeof valeur === 'string' && /^[=+@\t-]/.test(texte)) texte = `'${texte}`;
    return `"${texte.replace(/"/g, '""')}"`;
}

export function toCsv(pavsRetenus, etats, index) {
    const lignes = [COLONNES.map(champ).join(';')];
    for (const pav of pavsRetenus) {
        const p = proprietes(pav, etats.get(pav.id), index);
        lignes.push(COLONNES.map((c) => champ(p[c])).join(';'));
    }
    return `\uFEFF${lignes.join('\n')}`; // BOM UTF-8 (pour Excel)
}

export function toGeoJson(pavsRetenus, etats, index) {
    const features = [];
    for (const pav of pavsRetenus) {
        if (pav.lat == null || pav.lng == null) continue;
        features.push({
            type: 'Feature',
            geometry: {type: 'Point', coordinates: [pav.lng, pav.lat]},
            properties: proprietes(pav, etats.get(pav.id), index),
        });
    }
    return {type: 'FeatureCollection', features};
}
